import React from 'react';

const TelephonNumber = (props) => {
    return (  
    <div className="form-group">
        <div className="col-sm-4">
            <label htmlFor={props.name} className="form-label">{props.title}</label>
            {props.badge ? <span className='badge'>必須</span> : ''}
        </div>
        <div className="col-sm-8">
            { <input type="tel" id = {'0'} name={props.name} input={'number'} value={props.value} maxLength={'12'} onChange={props.handleChange} /*required*//>}
        </div>
    </div>
    );
}

export default TelephonNumber;